
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { VerificationLayout } from "@/components/auth/VerificationLayout";
import { VerificationForm } from "@/components/auth/VerificationForm";
import { ResendCodeButton } from "@/components/auth/ResendCodeButton";

const Verify = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  
  const email = location.state?.email || "";
  const token = location.state?.token || localStorage.getItem("authToken");
  
  useEffect(() => {
    if (!token) {
      // Redirect to login if no token is available
      toast({
        title: "Session expired",
        description: "Please log in again",
        variant: "destructive",
      });
      navigate("/login");
    }
  }, [token, navigate, toast]);

  return (
    <VerificationLayout email={email}>
      <VerificationForm token={token} email={email} />
      <ResendCodeButton token={token} />
    </VerificationLayout>
  );
};

export default Verify;
